// = Libs =
import { FC } from 'react';
import { IconProps } from '@/common/components/icons/icon.types';

// = Constants =
import COLORS from '@/constants/colors';

const AsteriskIcon: FC<IconProps> = ({ color = 'dark' }) => {
  const iconColor = COLORS[color];

  return (
    <svg viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.93196 0L4.59381 3.258L7.76907 2.33689L8 4.18763L5.03093 4.43497L6.97732 7.08742L5.33608 8L3.96701 5.11727L2.73814 8L1.04742 7.08742L2.95258 4.43497L0 4.18763L0.28866 2.33689L3.38969 3.258L3.05155 0H4.93196Z"
        fill={iconColor}
      />
    </svg>
  );
};

export default AsteriskIcon;
